import { stringify } from 'qs';

const AUTHENTICATE_PAGE_URL = 'https://www.cian.ru/authenticate/';

/**
 * Урл страницы авторизации.
 *
 * Нужен как фолбэк, когда модалку авторизации открыть нечем — например,
 * недоступно API микрофронтенда шапки.
 *
 * @param backUrl - урл, на который вернет пользователя после авторизации
 */
export function getAuthenticateUrl(backUrl: string) {
  return `${AUTHENTICATE_PAGE_URL}${stringify({ back_url: backUrl }, { addQueryPrefix: true })}`;
}
